export default {
  DOCUMENT_NAME: "Document Name",
}
